import React from "react";
import {
  styled,
  Badge,
  withStyles,
  createStyles,
  Theme,
  Grid,
} from "@material-ui/core";
import { IStyledArguments } from "../../types/styled-arguments";
import Link from "../link";
import Typography from "../typography";

export const OwnGoalBadge = withStyles((theme: Theme) =>
  createStyles({
    badge: {
      backgroundColor: theme.palette.extra.loss,
      boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
      "&::after": {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        borderRadius: "50%",
        animation: "$ripple 1.2s infinite ease-in-out",
        border: `1px solid ${theme.palette.extra.loss}`,
        content: '""',
      },
    },
    "@keyframes ripple": {
      "0%": {
        transform: "scale(.8)",
        opacity: 1,
      },
      "100%": {
        transform: "scale(2.4)",
        opacity: 0,
      },
    },
  })
)(Badge);

export const Header = styled("div")(({ theme }: IStyledArguments) => ({
  background: theme.palette.extra.lighterGrey,
  display: "flex",
  justifyContent: "space-between",
  padding: theme.spacing(1, 1.5, 1, 1.5),
}));

export const Content = styled("div")(({ theme }: IStyledArguments) => ({
  background: theme.palette.extra.default,
  // minHeight: `calc(100vh - ${theme.layout.headerHeight +
  //   theme.layout.tabsHeight}px )`,
  minHeight: "100%",
  display: "flex",
  justifyContent: "space-between",
  padding: theme.spacing(1, 1.5, 1, 1.5),
}));

export const Centered = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  // padding: theme.spacing(1, 1.5, 1, 1.5)
}));

export const Title = styled(Link)(({ theme }: IStyledArguments) => ({
  ...theme.typography.h6,
  marginBottom: 0,
}));

export const ButtonRow = styled("div")(({ theme }: IStyledArguments) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  paddingTop: theme.spacing(2),
}));

export const CreatedDate = styled(Typography.Subtitle1)(() => ({
  textAlign: "right",
}));

export const Container = styled((props) => (
  <Grid container {...props} direction="row" />
))({
  flex: 1,
  justifyContent: "space-between",
  paddingBottom: 8,
});

export const AwayTeamButton = styled("div")(({ theme }: IStyledArguments) => ({
  paddingLeft: theme.spacing(2),
}));

export const RedCardIcon = () => (
  <svg
    id="Capa_1"
    enableBackground="new 0 0 496.38 496.38"
    height="25px"
    viewBox="0 0 496.38 496.38"
    width="25px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#fed2a4">
      <path d="m275.932 162.95h35.507v46.275h-35.507z" />
      <path d="m206.14 281.07v2 18.57c0 14.68-11.91 26.59-26.59 26.59h-9.51c-3.43 0-6.21-2.78-6.21-6.2v-40.96z" />
      <path d="m248.29 283.85-4.975-4.975h-37.175v5.195 2 15.57 28.04c0 3.43 2.77 6.2 6.2 6.2h9.51c14.69 0 26.59-11.9 26.59-26.59l.1-23.22c-.02-.75-.11-1.49-.25-2.22z" />
    </g>
    <path
      d="m181.651 322.03v-40.96h-17.821v40.96c0 3.42 2.78 6.2 6.21 6.2h9.51c1.938 0 3.826-.213 5.646-.607-2.094-.998-3.545-3.126-3.545-5.593z"
      fill="#ffbd86"
    />
    <path
      d="m223.961 329.68v-28.04-15.57-2-5.195h-17.821v5.195 2 15.57 28.04c0 3.43 2.77 6.2 6.2 6.2h9.51c1.938 0 3.826-.213 5.646-.606-2.09-.996-3.535-3.12-3.535-5.594z"
      fill="#ffbd86"
    />
    <path
      d="m74.46 0v265.11c0 10.47 8.49 18.96 18.97 18.96h70.4 42.31 39.93 51.38v-41.67-33.21-46.24-162.95z"
      fill="#fe646f"
    />
    <path
      d="m276.45 191.891-39.804-39.593c-9.306-9.266-21.664-14.367-34.797-14.367-13.283 0-25.739 5.201-35.07 14.642-9.195 9.297-14.259 21.619-14.259 34.697 0 12.313 4.563 24.103 12.831 33.175l17.667 19.436c3.474 3.821.762 9.95-4.402 9.95-36.125 0-65.418-29.27-65.446-65.395l-.145-184.436h-38.565v265.11c0 10.47 8.49 18.96 18.97 18.96h70.4 42.31 17.044 22.886 51.38v-34.239-7.431-29.106z"
      fill="#fd4755"
    />
    <path
      d="m419.64 266.43-29.18-58.54c-8.32-16.69-22.81-29.49-40.4-35.68l-24.862-8.757c-.945-.333-1.94-.503-2.942-.503h-24.806v46.24h12.45c13.189 0 23.88 10.691 23.88 23.88v20.44c0 9.27-11.19 13.92-17.75 7.38l-18.58-18.49-75.62-75.22c-11.11-11.06-29.1-10.99-40.12.16-5.45 5.51-8.19 12.71-8.19 19.93 0 6.81 2.44 13.64 7.37 19.05l63.62 69.99c1.96 2.13 3.26 4.75 3.78 7.54.14.73.23 1.47.25 2.22.02.21.02.42.02.63v81.1c0 20.3 12.37 37.7 29.98 45.09v78.964c0 2.5 2.026 4.526 4.526 4.526h116.798c2.5 0 4.526-2.026 4.526-4.526v-77.008c10.251-3.95 17.53-13.892 17.53-25.536v-12.47-100.72c0-3.36-.78-6.68-2.28-9.69z"
      fill="#fed2a4"
    />
    <path
      d="m419.047 400.189v1.33c.27-.54.515-1.092.75-1.651-.251.105-.495.223-.75.321z"
      fill="#ffbd86"
    />
    <path
      d="m293.197 401.303c0-1.833-1.055-3.49-2.699-4.301-16.162-7.974-27.281-24.613-27.281-43.859v-81.1c0-.21 0-.42-.02-.63-.02-.75-.11-1.49-.25-2.22-.52-2.79-1.82-5.41-3.78-7.54l-63.62-69.99c-4.93-5.41-7.37-12.24-7.37-19.05 0-3.867.794-7.726 2.361-11.325-3.211 1.397-6.217 3.41-8.829 6.052-5.45 5.51-8.19 12.71-8.19 19.93 0 6.81 2.44 13.64 7.37 19.05l63.62 69.99c1.96 2.13 3.26 4.75 3.78 7.54.14.73.23 1.47.25 2.22.02.21.02.42.02.63v81.1c0 20.3 12.37 37.7 29.98 45.09v78.964c0 2.5 2.026 4.526 4.526 4.526h116.798c2.5 0 4.526-2.026 4.526-4.526v-10.131h-30.773c-44.414 0-80.419-36.005-80.419-80.42z"
      fill="#ffbd86"
    />
    <path
      d="m333.78 233.08v15.302c6.473 2.941 14.657-1.601 14.657-9.529v-20.43c0-13.194-10.696-23.89-23.89-23.89-6.87 0-12.44-5.57-12.44-12.44v-19.143h-14.657v46.24h12.44c13.194 0 23.89 10.696 23.89 23.89z"
      fill="#ffbd86"
    />
  </svg>
);

export const YellowCardIcon = () => (
  <svg
    id="Capa_1"
    enableBackground="new 0 0 496.035 496.035"
    height="25px"
    viewBox="0 0 496.035 496.035"
    width="25px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#fed2a4">
      <path d="m331.672 186.675h35.42v80.971h-35.42z" />
      <path d="m139.152 210.415h-11.61c-12.71 0-23.01 10.3-23.01 23 0 6.35 2.58 12.11 6.74 16.27s9.92 6.74 16.27 6.74h28.5 32.325v-46.01z" />
      <path d="m229.962 256.425h-54.48c-12.71 0-23.01 10.3-23.01 23.01 0 6.35 2.58 12.1 6.74 16.26 4.16 4.17 9.92 6.74 16.27 6.74h13.72 59.363v-46.01z" />
    </g>
    <path
      d="m127.542 233.42c-6.35 0-12.11-2.58-16.27-6.74-1.416-1.416-2.643-3.02-3.653-4.766-1.96 3.385-3.087 7.31-3.087 11.501 0 6.35 2.58 12.11 6.74 16.27s9.92 6.74 16.27 6.74h28.5 32.325v-23.005h-32.325z"
      fill="#ffbd86"
    />
    <path
      d="m175.482 279.43c-6.35 0-12.11-2.57-16.27-6.74-1.416-1.416-2.643-3.019-3.653-4.764-1.96 3.386-3.087 7.314-3.087 11.509 0 6.35 2.58 12.1 6.74 16.26 4.16 4.17 9.92 6.74 16.27 6.74h13.72 59.363v-23.005h-59.363z"
      fill="#ffbd86"
    />
    <path
      d="m140.659 0c-.831-.003-1.507.67-1.507 1.501v208.913 29.12c0 9.328 7.562 16.89 16.89 16.89h17.35 2.09 54.48l61.75 1.45h39.96 16.94c8.59 0 15.55-7.56 15.55-16.89v-54.31-184.403c0-.827-.669-1.499-1.496-1.501z"
      fill="#fef056"
    />
    <path
      d="m325.868 224.993c-7.284-.064-13.156-5.987-13.156-13.271v-55.848c0-28.434-22.492-52.275-50.921-52.791-29.039-.527-52.829 22.941-52.829 51.861 0 15.375-21.713 18.429-26.032 3.673-2.372-8.105-3.644-16.679-3.644-25.551v-132.881c0-.028-.023-.051-.051-.051l-38.525-.134c-.859-.003-1.558.693-1.558 1.552v208.862 29.069c0 9.356 7.585 16.941 16.941 16.941h17.299 2.09 29.006 25.474l61.75 1.45h39.96 3.017 13.923c8.59 0 15.55-7.56 15.55-16.89v-15.607c-.02-.02-.031-.031-.05-.051z"
      fill="#fee45a"
    />
    <path
      d="m300.062 425.395v67.117c0 1.946-1.577 3.523-3.523 3.523h-134.493c-1.946 0-3.523-1.577-3.523-3.523v-130.547c0-17.84 6.93-34.98 19.33-47.8l11.35-11.73 38.07-39.36c1.72-1.78 2.69-4.17 2.69-6.65v-101.48c0-17.049 13.821-30.87 30.87-30.87h.01c17.049 0 30.87 13.821 30.87 30.87v102.93 42.26c0 4.54 4.99 7.31 8.84 4.92l22.09-13.73c5.61-3.48 9.03-9.62 9.03-16.23v-17.22h16.94c8.59 0 15.55-7.56 15.55-16.89v-54.31h11.11c8.964 0 16.23 7.266 16.23 16.23v131.84c0 14.88-5.911 29.151-16.433 39.673l-39.547 39.547c-7.33 7.32-17.26 11.43-27.61 11.43z"
      fill="#fed2a4"
    />
    <path
      d="m187.247 492.511v-130.546c0-17.84 6.93-34.98 19.33-47.8l11.35-11.73 38.07-39.36c1.72-1.78 2.69-4.17 2.69-6.65v-101.48c0-11.864 6.697-22.159 16.513-27.327-4.29-2.259-9.172-3.543-14.357-3.543h-.01c-17.049 0-30.87 13.821-30.87 30.87v101.48c0 2.48-.97 4.87-2.69 6.65l-38.07 39.36-11.35 11.73c-12.4 12.82-19.33 29.96-19.33 47.8v130.547c0 1.946 1.577 3.523 3.523 3.523h28.724c-1.946 0-3.523-1.578-3.523-3.524z"
      fill="#ffbd86"
    />
  </svg>
);
export const GoalIcon = () => (
  <svg
    height="25px"
    viewBox="0 0 496 496"
    width="25px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="m456 0h-416c-22.054688 0-40 17.945312-40 40v216h186.105469c-39.984375 22.167969-66.105469 64.816406-66.105469 112 0 70.574219 57.425781 128 128 128s128-57.425781 128-128c0-47.183594-26.121094-89.832031-66.105469-112h186.105469v-216c0-22.054688-17.945312-40-40-40zm-128.960938 352.753906 32.738282 19.636719c-.738282 18.753906-6.050782 36.304687-14.929688 51.609375h-44.847656l-19.457031-25.9375 6.386719-31.933594zm19.242188-38.296875c6.488281 11.878907 10.796875 24.992188 12.648438 38.765625l-21.3125-12.78125zm-80.839844 77.542969h-34.882812l-5.726563-28.625 23.167969-17.375 23.167969 17.375zm-69.441406 32h-44.847656c-8.816406-15.183594-14.113282-32.585938-14.914063-51.175781l40.121094-20.054688 32.648437 13.054688 6.449219 32.238281zm-59.097656-69.390625c1.839844-15.210937 6.753906-29.617187 14.203125-42.503906l14.160156 28.320312zm87.097656-66.609375v-96h-14.367188l38.367188-43.847656 38.367188 43.847656h-14.367188v96zm-108.6875-64 36.6875-36.6875 52.6875 52.6875h-73.375zm-6.625 16h-9.375l4.6875-4.6875zm-60.6875-83.3125v-57.375l8-8 36.6875 36.6875-36.6875 36.6875zm56-17.375 36.6875 36.6875-36.6875 36.6875-36.6875-36.6875zm344-40v57.375l-8 8-36.6875-36.6875 36.6875-36.6875zm-19.3125 76.6875-36.6875 36.6875-36.6875-36.6875 36.6875-36.6875zm-84.6875-11.3125-36.6875-36.6875 36.6875-36.6875 36.6875 36.6875zm-11.3125 11.3125-20.832031 20.832031-34.816407-39.792969.625.625 18.335938-18.351562zm-32 32-12.6875 12.6875v-12.6875zm-33.632812-62.367188-19.054688-21.785156-19.054688 21.777344-17.632812-17.625 36.6875-36.6875 36.6875 36.6875zm-48.671876 12.0625-34.238281 39.136719-20.832031-20.832031 36.6875-36.6875zm-10.382812 62.992188-12.6875-12.6875h12.6875zm-56-56-36.6875-36.6875 36.6875-36.6875 36.6875 36.6875zm192 22.625 36.6875 36.6875-16 16h-73.375zm48 48 4.6875 4.6875h-9.375zm11.3125-11.3125 36.6875-36.6875 8 8v44.6875h-28.6875zm44.6875-163.3125-8 8-20.6875-20.6875h28.6875zm-51.3125-12.6875 32 32-36.6875 36.6875-36.6875-36.6875 32-32zm-52.6875 20.6875-20.6875-20.6875h41.375zm-43.3125-20.6875 32 32-36.6875 36.6875-36.6875-36.6875 32-32zm-52.6875 20.6875-20.6875-20.6875h41.375zm-43.3125-20.6875 32 32-36.6875 36.6875-36.6875-36.6875 32-32zm-52.6875 20.6875-20.6875-20.6875h41.375zm-43.3125-20.6875 32 32-36.6875 36.6875-36.6875-36.6875 32-32zm-52.6875 20.6875-8-8v-12.6875h28.6875zm-8 126.625 8-8 36.6875 36.6875-16 16h-28.6875zm160 68.085938v40.601562h32v28l-25.199219 18.902344-33.007812-13.199219-20.304688-40.613281c12.136719-14.84375 28.023438-26.617188 46.511719-33.691406zm-45.664062 176.601562h31.632812l8.664062 30.304688c-15.648437-6.960938-29.410156-17.367188-40.296874-30.304688zm58.71875 36.585938-12.269532-42.96875 19.214844-25.617188h40l19.214844 25.625-12.269532 42.96875c-8.648437 2.140625-17.640624 3.40625-26.945312 3.40625s-18.296875-1.265625-26.945312-3.414062zm72.320312-6.28125 8.65625-30.304688h31.632812c-10.886718 12.9375-24.648437 23.34375-40.289062 30.304688zm41.632812-172.625-13.328124 39.992187-40.230469 13.40625-25.449219-19.078125v-28h32v-40.601562c18.734375 7.167968 34.808594 19.167968 47.007812 34.28125zm144.992188-57.679688h-16v-208h-432v208h-16v-200c0-13.230469 10.769531-24 24-24h416c13.230469 0 24 10.769531 24 24zm0 0"
      fill="#0E7C86"
    />
  </svg>
);

export const TacticsIcon = () => (
  <svg
    height="120px"
    viewBox="-56 0 496 496"
    width="120px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="m0 456c0 22.054688 17.945312 40 40 40h304c22.054688 0 40-17.945312 40-40v-416c0-22.054688-17.945312-40-40-40h-304c-22.054688 0-40 17.945312-40 40zm288 24h-32v-32h-128v32h-32v-64h192zm-48 0h-96v-16h96zm104 0h-40v-80h-224v80h-40c-13.230469 0-24-10.769531-24-24v-200h73.910156c-1.222656 7.929688-1.910156 15.945312-1.910156 24h16c0-8.0625.761719-16.089844 2.113281-24h30.527344c3.902344 27.089844 27.207031 48 55.359375 48s51.457031-20.910156 55.359375-48h120.640625v200c0 13.230469-10.769531 24-24 24zm-112.808594-224c-3.71875 18.230469-19.871094 32-39.191406 32s-35.472656-13.769531-39.191406-32zm-78.382812-16c3.71875-18.230469 19.871094-32 39.191406-32s35.472656 13.769531 39.191406 32zm-56.808594-224h32v32h128v-32h32v64h-192zm48 0h96v16h-96zm-104 0h40v80h224v-80h40c13.230469 0 24 10.769531 24 24v200h-120.640625c-3.902344-27.089844-27.207031-48-55.359375-48s-51.457031 20.910156-55.359375 48h-26.832031c3.121094-10.6875 7.421875-21.03125 12.984375-30.761719l12.160156-21.269531-13.890625-7.9375-12.160156 21.273438c-6.957032 12.175781-12.222656 25.207031-15.734375 38.695312h-77.167969v-200c0-13.230469 10.769531-24 24-24zm16 176c13.230469 0 24-10.769531 24-24s-10.769531-24-24-24-24 10.769531-24 24 10.769531 24 24 24zm0-32c4.414062 0 8 3.585938 8 8s-3.585938 8-8 8-8-3.585938-8-8 3.585938-8 8-8zm136 0c13.230469 0 24-10.769531 24-24s-10.769531-24-24-24-24 10.769531-24 24 10.769531 24 24 24zm0-32c4.414062 0 8 3.585938 8 8s-3.585938 8-8 8-8-3.585938-8-8 3.585938-8 8-8zm128 96c13.230469 0 24-10.769531 24-24s-10.769531-24-24-24-24 10.769531-24 24 10.769531 24 24 24zm0-32c4.414062 0 8 3.585938 8 8s-3.585938 8-8 8-8-3.585938-8-8 3.585938-8 8-8zm-264 144c-13.230469 0-24 10.769531-24 24s10.769531 24 24 24 24-10.769531 24-24-10.769531-24-24-24zm0 32c-4.414062 0-8-3.585938-8-8s3.585938-8 8-8 8 3.585938 8 8-3.585938 8-8 8zm264-32c-13.230469 0-24 10.769531-24 24s10.769531 24 24 24 24-10.769531 24-24-10.769531-24-24-24zm0 32c-4.414062 0-8-3.585938-8-8s3.585938-8 8-8 8 3.585938 8 8-3.585938 8-8 8zm-200.40625-68.28125-11.3125 11.3125 11.3125 11.3125-11.3125 11.3125-11.3125-11.3125-11.3125 11.3125-11.3125-11.3125 11.3125-11.3125-11.3125-11.3125 11.3125-11.3125 11.3125 11.3125 11.3125-11.3125zm185.375.5625-11.3125 11.3125-11.3125-11.3125 11.3125-11.3125-11.3125-11.3125 11.3125-11.3125 11.3125 11.3125 11.3125-11.3125 11.3125 11.3125-11.3125 11.3125 11.3125 11.3125-11.3125 11.3125zm0 0"
      fill="#0E7C86"
    />
  </svg>
);
export const SubstitutionIcon = () => (
  <svg
    height="32px"
    viewBox="0 0 64 64"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >    <g id="Substitute-2" data-name="Substitute">
      <path
        d="m29 22v-6a1 1 0 0 0 -1-1h-10a1 1 0 0 0 -1 1 2 2 0 0 1 -4 0 1 1 0 0 0 -1-1h-10a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h4v11a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-11h4a1 1 0 0 0 1-1zm-2-1h-4a1 1 0 0 0 -1 1v11h-14v-11a1 1 0 0 0 -1-1h-4v-4h8.126a4 4 0 0 0 7.748 0h8.126z"
        fill="#0E7C86"
      />
      <path
        d="m23 36h-16a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-12a1 1 0 0 0 -1-1zm-1 12h-6v-4a1 1 0 0 0 -2 0v4h-6v-10h14z"
        fill="#0E7C86"
      />
      <path
        d="m16 23h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z"
        fill="#0E7C86"
      />
      <path
        d="m18 24a1 1 0 0 0 1 1h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 -1 1z"
        fill="#0E7C86"
      />
      <path
        d="m62 15h-10a1 1 0 0 0 -1 1 2 2 0 0 1 -4 0 1 1 0 0 0 -1-1h-10a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h4v11a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-11h4a1 1 0 0 0 1-1v-6a1 1 0 0 0 -1-1zm-1 6h-4a1 1 0 0 0 -1 1v11h-14v-11a1 1 0 0 0 -1-1h-4v-4h8.126a4 4 0 0 0 7.748 0h8.126z"
        fill="#0E7C86"
      />
      <path
        d="m57 36h-16a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-12a1 1 0 0 0 -1-1zm-1 12h-6v-4a1 1 0 0 0 -2 0v4h-6v-10h14z"
        fill="#0E7C86"
      />
      <path
        d="m50 23h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z"
        fill="#0E7C86"
      />
      <path
        d="m52 24a1 1 0 0 0 1 1h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 -1 1z"
        fill="#0E7C86"
      />
      <path
        d="m10 47h2a1 1 0 0 0 0-2h-2a1 1 0 0 0 0 2z"
        fill="#0E7C86"
      />
      <path
        d="m44 47h2a1 1 0 0 0 0-2h-2a1 1 0 0 0 0 2z"
        fill="#0E7C86"
      />
      <path
        d="m32.707 24.293a1 1 0 0 0 -1.707.707v2h-3a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h3v2a1 1 0 0 0 1.707.707l5-5a1 1 0 0 0 0-1.414zm.293 8.293v-.586a1 1 0 0 0 -1-1h-3v-2h3a1 1 0 0 0 1-1v-.586l2.586 2.586z"
        fill="#0E7C86"
      />
      <path
        d="m37 40h-3v-2a1 1 0 0 0 -1.707-.707l-5 5a1 1 0 0 0 0 1.414l5 5a1 1 0 0 0 1.707-.707v-2h3a1 1 0 0 0 1-1v-4a1 1 0 0 0 -1-1zm-1 4h-3a1 1 0 0 0 -1 1v.586l-2.586-2.586 2.586-2.586v.586a1 1 0 0 0 1 1h3z"
        fill="#0E7C86"
      />
    </g>
  </svg>
);
